import mathUtils from '../../../utils/mathUtils';
import {
  CreateUpdateContractEstimateItemDto,
  GetContractExtendedDto,
  GetEstimateItemContractDto,
  GetEstimateItemDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';

import { getNotAssignedAmount } from './contractEstimateItemGridUtils';

const checkEstimatesValue = (
  availableItem?: GetEstimateItemDto,
  itemAmount?: string,
  sumFromSaved?: string,
  availableAmount?: string,
) => {
  if (!availableItem) {
    return false;
  }

  return (
    mathUtils.multiply(
      availableItem.purchaseNetTotal,
      mathUtils.add(availableAmount, sumFromSaved),
    ) < mathUtils.multiply(itemAmount, availableItem.purchaseNetTotal)
  );
};

export const checkDivergedContractAmounts = (
  contractEstimateItems: CreateUpdateContractEstimateItemDto[],
  availableEstimateItems: GetEstimateItemContractDto[],
  extendedContract?: GetContractExtendedDto,
) => {
  const hasNegativeAmounts = contractEstimateItems.some(item => {
    const avItem = availableEstimateItems.find(
      availableItem => availableItem.id === item.estimateItemId,
    );
    return (
      avItem &&
      mathUtils.multiply(avItem.purchaseNetTotal, avItem.purchaseNetTotal) <
        mathUtils.multiply(avItem.purchaseNetTotal, item.amount)
    );
  });

  const hasMoreThenAvailableAmounts = contractEstimateItems.some(item => {
    const availableItem = availableEstimateItems.find(
      availableItem => availableItem.id === item.estimateItemId,
    );

    const sumFromSaved =
      extendedContract?.contractEstimateItems?.find(
        curr => curr.estimateItem.id === availableItem?.id,
      )?.amount ?? '0';
    if (!availableItem) {
      return false;
    }
    const availableAmount = getNotAssignedAmount(availableItem);
    return checkEstimatesValue(
      availableItem,
      item.amount,
      sumFromSaved,
      availableAmount.toString(),
    );
  });

  return { hasNegativeAmounts, hasMoreThenAvailableAmounts };
};
